import React, { Component,useState,useEffect,useContext } from 'react';
import { Redirect , Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import BlueButton from '../../Components/BlueButton';
import Header from "../../Components/Lista/HeaderCheckin";
import AppContext from '../../Context/AppContext';
import realtimeDB from "../../Utils/api";

const InputContainer=styled.div`
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
`;

const InputText=styled.input`
text-align:center;
margin-top:7.5px;
border: 1px solid #bbbbbd;
font-size:18px;
width:297px;
height:55px;
border-radius:6px;
outline:none;

@media screen and (max-width:428px)
{
    width:100%;
}
`;

const SubText=styled.p`
margin:7.5px 0 0 0 0;
color:red;
justify-self:start;
`;

const StyledLink=styled(Link)`
text-decoration:none;
`;

const Button=styled.button`
display:grid;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 15px auto;
font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
font-size:16px;
font-weight:700;
border-radius:6px;
border:none;
height: 54px;
width: 300px;
margin-bottom: 0;
padding:1em;
color:white;
outline:none;
background-color: rgb(0, 136, 255);
cursor:pointer;

@media screen and (max-width:428px)
{
  width:100%;
  border-radius:0px;
  position:fixed;
  bottom:0;
}`;

const Telefono=()=>
{
    const History=useHistory();
    const {Customer} = useContext(AppContext);
    const [Phone, setPhone] = useState("")
    const [CorrectFormat, setCorrectFormat] = useState(false);
    const [ErrorFormat, setErrorFormat] = useState("")
                          
    useEffect(() => 
    {
        const {name}=Customer;
        if(name==="")
        {
           History.push("/lista");
        }
    }, [])

    const handleValidatePhone=e=>
    {
        setPhone(e.target.value);
       
        if(e.target.value.toString().length === 10)
        {
    
            realtimeDB.ref("/Customers").on("value",snapshot =>
            {
                var currentPhone=String(Phone);
                
                if(snapshot.exists() ===false)
                {
                    setCorrectFormat(true);
                    setErrorFormat(undefined);
                    return true;
                }
                snapshot.forEach(customer =>
                {
                    var customerPhone=String(customer.val().phone);
                    var correctFormat=customerPhone.substring(3,customerPhone.length);
                    
                    if(correctFormat===currentPhone && customer.val().status !== "served")
                    {
                        setCorrectFormat(false);
                        setErrorFormat("El número ya existe en la lista");
                        return false;
                    }
                    else
                    {
                        setCorrectFormat(true);
                        setCorrectFormat(true);
                        setErrorFormat(undefined);
                        return true;
                    }
                })
            });
         
        }
        else
        {   
            if(e.target.value.toString().length < 10)
            {
                setCorrectFormat(false);
                setErrorFormat("Mínimo 10 carácteres");
                return false;
            }
        }
    }

    const Submit=()=>
    {
        Customer.phone=Phone;
        History.push("/lista/nota");
    }

    return <>
    <Header/>
    <div style={{margin:"20px 0 0"}}>
        <InputContainer>
            <h2 style={{justifySelf:"start",margin:"7.5px 0 0 0"}}>Teléfono <span style={{color:"red"}}>*</span></h2>
            {CorrectFormat  ? <InputText autoFocus maxLength={10} type="tel" value={Phone} onChange={handleValidatePhone}/> : <InputText autoFocus type="number" value={Phone} onChange={handleValidatePhone} style={{border:"1px solid red"}}/>}
            {!CorrectFormat ? <SubText>{ErrorFormat}</SubText> : ""}
        </InputContainer>
    </div>
    {CorrectFormat ? <BlueButton onClick={Submit}>Confirmar</BlueButton> : null}
    </>
}


export default Telefono;